
import { usePartner } from '@/context/PartnerContext'
import { useApp } from '@/hooks/useApp'
import { ExportForm } from 'BrokerTsLib/src/containers'
import { ExportGroup } from 'BrokerTsLib/src/enums'
import { ExportWrapper } from './ExportWrapper'

export const OffersExportForm = () => {
  const { currentPartner } = usePartner()
  const { product } = useApp()

  return <ExportWrapper>
    <ExportForm product={product!} allowEmail={currentPartner?.partner != 'Jap'} group={ExportGroup.ListOffers} />
  </ExportWrapper>
}
